import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import moment from 'moment/moment'
import TextareaAutosize from 'react-textarea-autosize'
import * as timeago from 'timeago.js'
import style from './chatscreen.module.scss'

// eslint-disable-next-line import/imports-first
// eslint-disable-next-line import/imports-first
import { images } from '../../assets'
import { database, storageRef } from '../../utils/firebase'
import Spinner from '../../components/Spinner'
import PopupModal from '../../components/ToggleModal/PopupModal'
import { path } from '../../utils/const'
import { actions } from '../../slices/patient.slices'
import { endDelegateChat } from 'utils/network'

function ChatModule(props) {
  const inputRef = useRef(null)
  const { me } = useSelector((state) => state.app)
  const [message, setMessage] = useState([])
  const messageDiv = useRef(null)
  const [chatID, setChatID] = useState('')
  const [name, setName] = useState('')
  const [loading, setLoading] = useState(false)
  const [loadingModal, setLoadingModal] = useState(false)
  const [age, setAge] = useState(0)
  const [ageInYear, setAgeInYear] = useState(0)
  const [patientDate, setPatientDate] = useState('')
  const [patientID, setPatientID] = useState(null)
  const [doctorMsg, setDoctorMsg] = useState('')
  const [selectedImage, setSelectedImage] = useState('')
  const [imageKey, setImageKey] = useState('')
  const [openConvo, setOpenConvo] = useState({})
  const [delegateConvoObj, setDelegateConvoObj] = useState({})
  const navigate = useNavigate()
  const [endOpen, setEndOpen] = useState(false)
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const archiveId = query.get('archiveId')
  const contactSupport = path.sendmail
  const viewConsult = path.consultation
  const delegateConvoData = useSelector((state) => state.patient.delegateData)
  const patient = useSelector((state) => state.patient.patientData)
  const archiveID = useSelector((state) => state.patient.archiveId)
  const dispatch = useDispatch()

  // eslint-disable-next-line no-unused-vars
  const navigateBack = () => {
    navigate(-1)
  }
  const toggleModal = () => {
    setEndOpen((old) => !old)
  }
  let chatListener = null

  useEffect(async () => {
    if (archiveID !== archiveId) {
      dispatch(actions.fetchDelegateData(archiveId))
      dispatch(actions.fetchArchiveOpenData(archiveId))
    }
  }, [archiveID, archiveId])

  useEffect(() => {
    if (chatID) {
      if (chatListener) {
        chatListener.off()
        chatListener = null
      }
      chatListener = database.ref(`/conversations/${chatID}`)
      chatListener.on('value', (snapshot) => {
        const chatData = snapshot.toJSON() || {}
        const messageKeys = Object.keys(chatData)

        setMessage(
          messageKeys.map((key) => {
            return {
              ...chatData[key],
              key,
            }
          }),
        )
      })
    }

    return () => {
      if (chatListener) {
        chatListener.off()
      }
    }
  }, [chatID])

  useEffect(() => {
    if (!openConvo || Object.keys(openConvo).length <= 0) {
      if (delegateConvoObj?.delegateConversationInfo) {
        setOpenConvo(delegateConvoObj?.delegateConversationInfo)
      }
    }
  }, [openConvo, delegateConvoObj])

  useEffect(() => {
    if (delegateConvoData) {
      const date = moment(delegateConvoData?.DOB, 'MMMM DD YYYY')
      const years = moment().diff(date, 'years')
      setAgeInYear(years)
    }
    if (patient && openConvo) {
      let date = ''
      let years = ''
      if (
        openConvo.owner &&
        patient?.profiles &&
        patient?.profiles[openConvo.owner]
      ) {
        date = moment(patient?.profiles[openConvo.owner].DOB, 'MMMM DD YYYY')

        const convertDate = date.format('YYYY-MM-DD')
        setPatientDate(convertDate)

        years = moment().diff(date, 'years')
        setAge(years)
        setName(
          patient?.profiles[openConvo.owner].name ||
            patient?.profiles[openConvo.owner].userName ||
            '',
        )
      } else {
        date = moment(patient?.DOB, 'MMMM DD YYYY')

        const convertDate = date.format('YYYY-MM-DD')
        setPatientDate(convertDate)
        years = moment().diff(date, 'years')
        setAge(years)
        setName(patient?.name || patient?.userName || '')
      }
    }
  }, [patient, openConvo, delegateConvoData])

  // Derive chat identifiers directly from the delegateData the slice already loaded.
  // NOTE: this effect previously attached a SECOND, never-detached `.on('value')`
  // listener to /delegateChats/<archiveId>. Because /ChatModule is a single route that
  // does not unmount when the agent opens another chat, those listeners accumulated
  // (one per chat visited) and each re-downloaded the full chat node on every write —
  // the primary source of Realtime Database download egress. The slice's
  // fetchDelegateData already loads this node, so re-subscribing here was redundant.
  useEffect(() => {
    if (!delegateConvoData) return
    setDelegateConvoObj({ ...delegateConvoData, id: archiveId })
    setChatID(delegateConvoData?.conversationID || null)
    setPatientID(delegateConvoData?.patientID)
  }, [delegateConvoData, archiveId])

  // Load the open conversation ONCE per conversation (not on every metadata change).
  useEffect(() => {
    const conversationID = delegateConvoData?.conversationID
    if (!conversationID) return undefined
    let cancelled = false
    database
      .ref(`/openconversations/${conversationID}`)
      .once('value')
      .then((archiveSnapshot) => {
        if (!cancelled) setOpenConvo(archiveSnapshot.toJSON() || {})
      })
      .catch((e) => console.log(e))
    return () => {
      cancelled = true
    }
  }, [delegateConvoData?.conversationID])

  // eslint-disable-next-line no-shadow
  const handleCopyClick = (imageUrl) => {
    navigator.clipboard.writeText(imageUrl)
    // eslint-disable-next-line no-undef
    alert('Image URL copied to clipboard!')
  }

  const sendToEmail = () => {
    query.set('reason', `Support Query`)
    const emailPath = path.sendmail
    const paramsString = query.toString()
    const url = new URL(window.location.href)
    url.search = paramsString
    navigate(emailPath + url.search)
  }
  const sendToConsult = () => {
    const reviewPath = path.consultation
    const paramsString = query.toString()
    const url = new URL(window.location.href)
    url.search = paramsString
    navigate(reviewPath + url.search)
  }

  const handletextAreaChange = (e) => {
    const { value } = e.target
    setDoctorMsg(value)
  }

  useEffect(async () => {
    try {
      const newKey = database.ref(`/conversations/${chatID}/`).push().key
      const updates = {}
      if (selectedImage) {
        setLoading(true)
        const ref = storageRef().ref(
          `consultAttachment/${new Date().getTime()}`,
        )
        // eslint-disable-next-line no-await-in-loop
        const snapshot = await ref.put(selectedImage)
        // eslint-disable-next-line no-await-in-loop
        const str = await snapshot.ref.getDownloadURL()

        updates[`/conversations/${chatID}/${newKey}/content`] = str
        updates[`/conversations/${chatID}/${newKey}/doctorImgURL`] =
          me.profileImageURL
        updates[`/conversations/${chatID}/${newKey}/doctorName`] = me.doctorName
        updates[`/conversations/${chatID}/${newKey}/fromID`] = me.id
        updates[`/conversations/${chatID}/${newKey}/toID`] = patientID || null
        updates[`/conversations/${chatID}/${newKey}/isRead`] = false
        updates[`/conversations/${chatID}/${newKey}/timestamp`] =
          new Date().getTime()
        updates[`/conversations/${chatID}/${newKey}/type`] = 'image'
        if (archiveId) updates[`/delegateChats/${archiveId}/unReadCount`] = 0
        // eslint-disable-next-line no-use-before-define
        await database.ref().update(updates)

        setDoctorMsg('')
        setSelectedImage('')
        setImageKey(new Date().getTime().toString())
      }
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }, [selectedImage, imageKey])

  useEffect(() => {
    const objDiv = document.getElementById('data')
    objDiv.scrollTop = objDiv.scrollHeight

    messageDiv.current.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'nearest',
    })
  }, [messageDiv, message])

  const endConsult = async () => {
    try {
      setLoadingModal(true)
      const payload = {
        chatID: delegateConvoObj.id,
      }
      await endDelegateChat(payload)
      setLoadingModal(false)
      navigate(path.activeconsultationpage, { replace: true })
    } catch (e) {
      console.log(e)
      setLoadingModal(false)
      // eslint-disable-next-line no-undef
      alert('Something went wrong, please try again!')
    }
  }

  const sendMessage = async (id) => {
    try {
      setLoading(true)
      const newChatKey = database.ref(`/conversations/${id}/`).push().key
      const updates = {}
      if (doctorMsg) {
        updates[`/conversations/${id}/${newChatKey}/content`] = doctorMsg
        updates[`/conversations/${id}/${newChatKey}/doctorImgURL`] =
          me.profileImageURL
        updates[`/conversations/${id}/${newChatKey}/doctorName`] = me.doctorName
        updates[`/conversations/${id}/${newChatKey}/fromID`] = me.id
        updates[`/conversations/${chatID}/${newChatKey}/toID`] =
          patientID || null
        updates[`/conversations/${id}/${newChatKey}/isRead`] = false
        updates[`/conversations/${id}/${newChatKey}/timestamp`] = Date.now()
        updates[`/conversations/${id}/${newChatKey}/type`] = 'text'
        if (archiveId) updates[`/delegateChats/${archiveId}/unReadCount`] = 0
        await database.ref().update(updates)
        setLoading(false)
        setDoctorMsg('')
      }
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  return (
    <div className={style.chatMain}>
      <div className={style.header}>
        <div className={style.name}>
          <div className={style.backButton}>
            <button type="button" onClick={navigateBack}>
              <img src={images.backbutton} className={style.icon} alt="logo" />
            </button>
          </div>
          <div className={style.patientInfo}>
            <span className={style.patName}>
              {delegateConvoData?.patientName}
            </span>
            <div>
              <span className={style.patName}>D.O.B: </span>
              <span className={style.age}>
                {moment(delegateConvoData?.DOB).format('YYYY-MM-DD')}{' '}
              </span>
            </div>
            <div>
              <span className={style.patName}>Age: </span>
              <span className={style.age}> {ageInYear} </span>
            </div>
          </div>
        </div>

        {endOpen && (
          <PopupModal
            openConvo={openConvo}
            approve={'End consultation'}
            content={'Are you sure you want to end consultation?'}
            delegateConvoObj={delegateConvoObj}
            patientData={patientID}
            loading={loadingModal}
            handleClick={endConsult}
            toggleModal={toggleModal}
            endconsult={true}
          />
        )}

        {delegateConvoObj.status === 'active' &&
        delegateConvoObj.conversationID ? (
          <button className={style.endConsult} onClick={toggleModal}>
            End consultation
          </button>
        ) : (
          <button className={style.disableConsult}>End consultation</button>
        )}
      </div>

      <div className={style.consultButton}>
        <button
          className={style.viewConsult}
          onClick={(event) => sendToConsult(viewConsult, patientID)}
        >
          View consultation
        </button>
        <button
          className={style.viewConsult}
          onClick={(event) => sendToEmail(contactSupport)}
        >
          Contact support
        </button>
      </div>

      <div ref={messageDiv} className={style.chatBox} id="data">
        {message.map((obj) => {
          return (
            <div key={obj.key}>
              {obj.doctorName ? (
                <div className={style.time}>
                  <div className={style.doctorMsg}>
                    {obj.type === 'image' ? (
                      <div>
                        {' '}
                        <img
                          id="image"
                          src={obj.content}
                          className={style.imageSize}
                          alt="logo"
                        />
                        <button
                          className={style.copylink}
                          onClick={() => handleCopyClick(obj.content)}
                        >
                          Copy link
                        </button>
                      </div>
                    ) : (
                      <span>{obj.content}</span>
                    )}
                  </div>
                  <span className={style.doctorTimestamp}>
                    {timeago.format(obj.timestamp)}
                  </span>
                  <br />
                </div>
              ) : (
                <div className={style.UserTime}>
                  <div className={style.userMsg}>
                    {obj.type === 'image' ? (
                      <div>
                        {' '}
                        <img
                          src={obj.content}
                          className={style.UserImageSize}
                          alt="logo"
                        />
                        <button
                          className={style.copylink}
                          onClick={() => handleCopyClick(obj.content)}
                        >
                          Copy link
                        </button>
                      </div>
                    ) : (
                      <span>{obj.content}</span>
                    )}
                  </div>
                  <span className={style.userTimestamp}>
                    {timeago.format(obj.timestamp)}
                  </span>
                  <br />
                </div>
              )}
            </div>
          )
        })}
      </div>
      {delegateConvoObj.status !== 'closed' && me.role === 'Doctor' && (
        <div className={style.footer}>
          <div className={style.sendBox}>
            <div className={style.sendBoxRow}>
              <TextareaAutosize
                name="message"
                placeholder="Please type here"
                className={style.valid}
                value={doctorMsg}
                onChange={handletextAreaChange}
              />
            </div>

            {loading ? (
              <Spinner color="#DF7467" isLoading={loading} />
            ) : (
              <div className={style.attachmentButton}>
                <img
                  src={images.attachment}
                  onClick={() => inputRef.current.click()}
                  alt="logo"
                />
                <input
                  id="image"
                  name="image"
                  ref={inputRef}
                  type="file"
                  style={{ display: 'none' }}
                  accept="image/*"
                  key={imageKey}
                  onChange={(event) => {
                    setSelectedImage(event.target.files[0])
                  }}
                />
                {loading ? (
                  <Spinner color="#DF7467" isLoading={loading} />
                ) : (
                  <button
                    className={style.button}
                    onClick={(event) => sendMessage(chatID)}
                  >
                    <img src={images.send} className={style.send} alt="logo" />
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default ChatModule
